import { defineMessages } from 'react-intl';

export default defineMessages({
  new_conversation_inHours: {
    id: 'kustomer.chat.history.new_conversation_inHours',
    description: 'New convo button copy when in business hours',
    defaultMessage: 'Start a New Conversation',
  },
  new_conversation_afterHours: {
    id: 'kustomer.chat.history.new_conversation_afterHours',
    description: 'New convo button copy when after business hours',
    defaultMessage: 'Leave a Message',
  },
  new_conversation_singleChat: {
    id: 'kustomer.chat.history.new_conversation_singleChat',
    description: 'New convo button copy for single chat return to active chat',
    defaultMessage: 'Back to Chat',
  },
});
